// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JA5I3o6YBJITyJDlkChH {\n  display: grid;\n  justify-items: center;\n}\n.fz3dkeSulmP4Oe8LAPqa {\n  color: red;\n}\n", "",{"version":3,"sources":["webpack://./src/components/login-form/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,UAAU;AACZ","sourcesContent":[".login-form {\n  display: grid;\n  justify-items: center;\n}\n.error-message {\n  color: red;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"login-form": "JA5I3o6YBJITyJDlkChH",
	"error-message": "fz3dkeSulmP4Oe8LAPqa"
};
export default ___CSS_LOADER_EXPORT___;
